module.exports = __webpack_public_path__ + "img/40_38_087_400.25f318e6.jpg";